import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';

const MassOfferingMassRequestMinDateDescription = ({ massOfferingMassRequestMinDate }) => {
  return (
    <>
      Przez formularz online można zamówić intencje na Msze Święte odprawiane od{' '}
      <b>{moment(massOfferingMassRequestMinDate).format('DD.MM.YYYY')}</b>. W&nbsp;przypadku innej
      potrzeby, prosimy o&nbsp;bezpośredni kontakt z&nbsp;kancelarią.
    </>
  );
};

MassOfferingMassRequestMinDateDescription.propTypes = {
  massOfferingMassRequestMinDate: PropTypes.instanceOf(moment),
};

export default MassOfferingMassRequestMinDateDescription;
